'use strict';

const reviews = [
  '$rootScope',
  '$q',
  '$http',
  'utils',
  'userModel',
  'modal',

  function ($rootScope, $q, $http, utils, userModel) {
    function getApiUrl(revieweeId) {
      return utils.getApiUrl('/reviews/' + userModel.item.id + '/' + revieweeId);
    }

    return {
      fetchReviewInfo: function (revieweeId) {
        var deferred = $q.defer();

        $http.get(getApiUrl(revieweeId))
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(deferred.reject);

        return deferred.promise;
      },
      create: function (revieweeId, reviewData) {
        return $http.post(getApiUrl(revieweeId), reviewData);
      }
    };
  }
];

export default reviews;



// WEBPACK FOOTER //
// ./app/src/services/reviews.js